<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="100px"
  >

    <el-form-item
      prop="dimensionName"
      label="维度名称"
    >
      <el-input
        placeholder="维度名称"
        v-model="form.dimensionName"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="remark"
      label="备注"
    >
      <el-input
        placeholder="请输入"
        v-model="form.remark"
      ></el-input>
    </el-form-item>

  </el-form>
</template>

<script>
let origin = {
  id: '',
  dimensionName: '',
  remark: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "dimensionForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {};
      }
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        dimensionName: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue){
          // this.assigen(newValue);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mixins: [formLabalPosition],
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(tableListItem){
      this.form.id = tableListItem.id;
      this.form.dimensionName = tableListItem.dimensionName;
      this.form.remark = tableListItem.remark;
    },

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
